import * as clipboard from 'clipboard-polyfill'
// https://www.npmjs.com/package/clipboard-polyfill

const copy = (data) => {
  if (typeof window !== 'undefined') {
    const dt = new clipboard.DT()
    // html should be set first.
    if ('text/html' in data) dt.setData('text/html', data['text/html'])
    if ('text/plain' in data) dt.setData('text/plain', data['text/plain'])
    clipboard.write(dt)
  }
}

export const Clipboard = { ...clipboard, copy }

export default Clipboard
